var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('MainDisplay'),_c('AboutMe'),_c('Therapy'),_c('Worth'),_c('Requests'),_c('NotWorkWith')],1)}
var staticRenderFns = []

export { render, staticRenderFns }